import { WidgetsRoleFormMain } from '@/widgets/role-form';

export const PagesRoleCreateMain = () => <WidgetsRoleFormMain mode="create" />;
